export interface IAssetResolver {
    resolve(file: string): string;
}
